'use client';
import React, { useEffect } from 'react';
import ds from '@/styles/ds/ds.module.scss';
import { icons } from '@/Icons';
import { useUser } from '@/store';
import { ValidateField } from '@/features/Onboarding/components/Steps/VerificationLevel1/VerificationLevel1';

interface Buttons_Over18Props {
	isAtLeast18: boolean | null;
	setIsAtLeast18: (value: boolean) => void;
	validateField: ValidateField;
}
const Buttons_Over18 = ({
	isAtLeast18,
	setIsAtLeast18,
	validateField,
}: Buttons_Over18Props) => {
	const user = useUser();

	useEffect(() => {
		if (user?.moreDetails?.attestation) {
			setIsAtLeast18(true);
		}
	}, [user]);

	return (
		<div className="w-full flex flex-col gap-4">
			<h2 className="text-sm font-bold">Are you over the age of 18?</h2>
			<div className="flex gap-4 w-full">
				<button
					type="button"
					className={`${ds.button} ${ds.primary} ${isAtLeast18 === true ? 'bg-electric-sky' : 'bg-powder-blue'} h-10 flex gap-2 items-center`}
					onClick={() => {
						setIsAtLeast18(true);
						validateField('isAtLeast18', true);
					}}
				>
					<icons.circlecheckmark className="w-5 h-5 text-electric-martha" />
					Yes
				</button>
				<button
					type="button"
					className={`${ds.button} ${ds.primary} ${isAtLeast18 === false ? 'bg-electric-sky' : 'bg-powder-blue'} h-10 flex gap-2 items-center`}
					onClick={() => {
						setIsAtLeast18(false);
						validateField('isAtLeast18', false);
					}}
				>
					<icons.circleclose className="w-5 h-5 text-tokens-negative" />
					No
				</button>
			</div>
		</div>
	);
};

export default Buttons_Over18;
